import React, { useState } from 'react'
import { Category } from '../Types/category.types'
import { useCreateCategoryMutation, useGetCategoriesQuery, useUpdateCategoryMutation } from '../Service/categoriesApi';
import { initialCategory } from '../initialState';
import { categoryFields } from './../fields';
import EntityFormLayout from '../../Shared/Components/EntityFormLayout/EntityFormLayout';
import AccordionCard from '../../Shared/Components/AccordionCard/AccordionCard';
import UploadImagesForm from '../../Shared/Components/UploadImagesForm/UploadImagesForm';
import ImageIcon from '@mui/icons-material/Image';
import { useUploadCategoryImagesMutation } from '../Service/extendedCategoriesApi';

import { CategoriesRoutes } from '../../../Router/path';
import PublicIcon from '@mui/icons-material/Public';
import { FormRenderGroupTypes } from '../../Shared/Components/FormRenderer/FormRenderGroup.types';
import InfoIcon from '@mui/icons-material/Info';
import SearchIcon from '@mui/icons-material/Search';
import SettingsIcon from '@mui/icons-material/Settings';
import { Typography } from '@mui/material';
import { useEntityForm } from '../../Shared/Hooks/useEntityForm';




const CreateCategory = () => {


    const [createCategory, createStatus] = useCreateCategoryMutation()
    const [updateCategory, updateStatus] = useUpdateCategoryMutation()
    const [uploadCategoryImages, uploadState] = useUploadCategoryImagesMutation()
    const [createdCategoryId, setCreatedCategoryId] = useState<number | null>(null);

    const mutationStatus = createdCategoryId ? updateStatus : createStatus;
    const { data: categoryData, isLoading: isCategoryLoading } = useGetCategoriesQuery()

    const entityForm = useEntityForm<Category>({
        initialData: initialCategory,
        fields: categoryFields
            .filter(f => {
                if (!createdCategoryId && f.name === 'slug') return false;
                return true;
            })
            .map((field) => {
                if (field.type === "autocomplete" && categoryData) {
                    return {
                        ...field,
                        name: field.name as keyof Category,
                        options: categoryData.map((cat) => ({
                            label: cat.name,
                            value: cat.id,
                        })),
                        loading: isCategoryLoading,

                    };
                }
                return {
                    ...field,
                    name: field.name as keyof Category,

                }
            }),
        submitFn: (data) => {
            if (createdCategoryId) {
                return updateCategory({ id: createdCategoryId, data }).unwrap();
            } else {
                const { id, ...payload } = data;
                return createCategory(payload).unwrap();
            }
        },
        redirectUrl: CategoriesRoutes.root,
        mutationStatus,
        title: 'Dodaj Kategorię',
        icon: <PublicIcon />,
        backUrl: CategoriesRoutes.root,
        groupOrder: [
            FormRenderGroupTypes.basic,
            FormRenderGroupTypes.seo,
            FormRenderGroupTypes.configuration,
        ],
        groupIcons: {
            Podstawowe: <InfoIcon />,
            SEO: <SearchIcon />,
            Konfiguracja: <SettingsIcon />,
        },
        showSuccessBeforeRedirect: true,
        redirectDelay: 2000,
        onSuccessWithResponse: (response, shouldRedirect) => {
            if (!shouldRedirect && !createdCategoryId) {
                setCreatedCategoryId(response.categoryId);
            }
        },

    })
    return (
        <>
            <EntityFormLayout {...entityForm}>
                <AccordionCard title="Zdjęcia" icon={<ImageIcon />}>
                    {createdCategoryId ? (
                        <UploadImagesForm
                            useUploadMutation={() => [uploadCategoryImages, uploadState]}
                            mutationParams={(files) => ({ categoryId: createdCategoryId, files })}
                        />
                    ) : (
                        <Typography color="text.secondary">
                            Zdjęcia możesz dodać dopiero po zapisaniu kraju.
                        </Typography>
                    )}
                </AccordionCard>
            </EntityFormLayout>
        </>
    )
}

export default CreateCategory